import React from 'react'
import Slider from 'app/theme/slider'
import styles from './CateringOccasionsSlider.module.css'
import { useInView } from 'react-intersection-observer'
import workplaceImg from 'assets/img/workplace.jpg'
import weddingImg from 'assets/img/wedding-catering.jpg'
import campusImg from 'assets/img/campus-catering.jpg'
import largeImg from 'assets/img/large-event-banner.png'
import productionImg from 'assets/img/production-catering.jpg'
import communityImg from 'assets/img/community-concessions-banner.jpg'
import professionalImg from 'assets/img/professional-catering.jpg'
import privateImg from 'assets/img/party-catering-hero.jpg'
import businessLunchImg from 'assets/img/business-lunch-hero.jpg'

const defaultItems = [
  {
    type: 'workplace',
    title: 'Workplace Catering',
    description: 'Bring food trucks to your next employee or client appreciation day, team building exercise or simply to reward your staff with gourmet food. Including a catering option in your employee incentive program is a great way to motivate your staff.',
    image: workplaceImg,
    url: '/food-truck-catering/corporate-catering/',
  },
  {
    type: 'weddings',
    title: 'Weddings',
    description: "Finding a great wedding caterer is stressful - let our experienced team do the work so you don't have to. Once hired, your personal food truck coordinator will gather the best options available and help you select the caterer and menu that's right for you. Whether you want a unique food experience for your wedding reception, rehearsal dinner, late night snack or next day brunch, we are at your service.",
    image: weddingImg,
    url: '/food-truck-catering/food-truck-wedding/',
  },
  {
    type: 'campus',
    title: 'Food Trucks on Campus',
    description: 'Looking to feed your entire student body? Want to give your faculty a festive dining option? Bring food trucks to your next school or university event.',
    image: campusImg,
    url: '/food-truck-catering/campus-catering/',
  },
  {
    type: 'large',
    title: 'Large-Scale Events',
    description: 'We’re experts at understanding our partners’ needs and creating scalable custom food and beverage programs to meet your goals.',
    image: largeImg,
    url: '/food-truck-catering/large-event-food-concessions/',
  },
  {
    type: 'production',
    title: 'Production Catering',
    description: "Whether you're on the lot or on location, Roaming Hunger makes production catering turnkey with delicious food trucks.",
    image: productionImg,
    url: '/food-truck-catering/film-production-catering/',
  },
  {
    type: 'community',
    title: 'Community Events',
    description: "Feed hungry crowds at your next block party, street fair, or high school football game with fun and exciting food trucks.",
    image: communityImg,
    url: '/food-truck-catering/local-community-concessions/',
  },
  {
    type: 'professional',
    title: 'Professional Events',
    description: "Looking to feed an entire conference or convention of people? After a long day of walking, talking, and networking, your attendees, clients, and partners will love bonding over a savory and delicious meal from an amazing food truck.",
    image: professionalImg,
    url: '/food-truck-catering/conference-and-event-catering/',
  },
  {
    type: 'private',
    title: 'Private Parties',
    description: "Whether you're celebrating a birthday, graduation, Bar Mitzvah, anniversary or holiday, food trucks make your party more memorable.",
    image: privateImg,
    url: '/food-truck-catering/party-catering/',
  },
  {
    type: 'business_lunch',
    title: 'Business Lunch Catering',
    description: "We've worked with thousands of companies, large and small, to make lunch an experience the office will love. Whether you're feeding a small lunch meeting or the entire company, we'll get you options based on your dietary restrictions, preferences, and budget. Your local catering expert will take care of sourcing caterers in your area and manage the entire process. All you'll have to do is choose the best lunch options for your business and get ready to eat.",
    image: businessLunchImg,
    url: '/business-lunch-catering/',
  },
]

export default function CateringOccasionsSlider(props) {
  const {
    heading = 'Other catering occasions',
    occasions = defaultItems,
    buttonText = 'Get Started',
    className,
  } = props

  const [ref, inView] = useInView({
    rootMargin: '50px',
    triggerOnce: true,
  })

  return (
    <div ref={ref} className={[className]}>
      <div className="container">
        <h2 className="font-platform text-5xl text-center leading-tight mb-3 text-navy">
          {heading}
        </h2>
        <Slider
          lazyLoad={true}
          className="flex mx-auto"
          slidesToShow={2}
          slidesToScroll={2}
          arrows={false}
          dots={true}
          responsive={[
            {
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ]}
        >
          {occasions.map((item, index) => (
            <div key={index} className="p-4">
              <div
                className={[styles.image, 'w-full mb-2']}
                style={{ backgroundImage: inView ? `url('${item.image}')` : undefined }}
              />
              <h3 className="font-platform text-2xl leading-tight my-5 text-navy">
                {item.title}
              </h3>
              <p className="font-light leading-snug mb-5">
                {item.description}
              </p>
              <a
                href={item.url}
                className="btn btn-green font-platform text-1xl px-10 py-2"
                children={buttonText}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}
